
const NavButton=({name,classname,onClick,disabled,id,buttonref})=>
{
    return(
        <button ref={buttonref} id={id} disabled={disabled} onClick={onClick} className={`cursor-pointer ${classname}`}>{name}</button>
    )
}
export default NavButton